module.exports = __webpack_public_path__ + "band_8.67df9b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_8.png
// module id = OPil
// module chunks = 0